import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class FilialService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'filiais';
  }

  protected getBaseUrlPublic(): string {
    throw new Error("Método não suportado!");
  }

  semRelacionamento(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/semRelacionamento`);
  }

  listarComProjecao(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comProjecao`);
  }

  listarFiliaisComRelacaoMinimaDeMedico(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comRelacaoMinimaDeMedico`);
  }

  listarFiliaisComRelacaoMinimaDeEspecialidade(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comRelacaoMinimaDeEspecialidade`);
  }

  procurarPorIdSemRelacionamento(entityId: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/semRelacionamento/${entityId}`);
  }

  listarFilialPorMedicoEEspecialidade(idMedico: number, idEspecialidade: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/medico/${idMedico}/especialidade/${idEspecialidade}`);
  }

  atualizaRelacaoFilialMedico(value: any): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/relacaoFilialMedico`, value);
  }

  atualizaRelacaoFilialEspecialidade(value: any): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/relacaoFilialEspecialidade`, value);
  }

}
